module.exports = __webpack_public_path__ + "changelog-3-2ea420e71263a13c308e3c1154fd748a.webp";